module.exports = __webpack_public_path__ + "img/a5594b0.png";